var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('app-header'),_c('q-nav-bar',{attrs:{"nav":"none"},on:{"back":function($event){return _vm.$router.push('/')}}}),_c('br'),_c('section-list',{attrs:{"view":"grid"},on:{"goto":_vm.goto}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }